import processEducatorData from '@api/processors/educator';

const processEducatorsEntity = (feedBlock) => ({
  label: feedBlock.label || feedBlock.extraBlockInfo.label || '',
  type: feedBlock.type,
  users: feedBlock.data.map((educator) => processEducatorData(educator)),
  extraBlockinfo: {
    count: feedBlock.data.length || 0,
    ...(feedBlock.extraBlockInfo || {})
  }
});

export default processEducatorsEntity;
